import React from 'react';
import Context from "../Utilities";

const Fragment = window.wp.element.Fragment;

function Question2() {
    return (
        <Context.Consumer>
            {({ toggleWhy, share }) => {
                function avoidQuestion() {
                    return (
                        <Fragment>
                            <div id="question2" class="questions">

                                <div class="question">
                                    <p>Here are some of the reasons why others have said they would avoid sharing their opinions with the group. Which best describes why you would avoid sharing your views?</p>
                                </div>
                                <div class="options">
                                    <button class="ui button" id="conflict" onClick={e => toggleWhy(e)}>I feel it would almost certainly lead to conflict</button>
                                    <button class="ui button" id="judged" onClick={e => toggleWhy(e)}>I know the people at the table would judge and criticize me</button>
                                    <button class="ui button" id="strong" onClick={e => toggleWhy(e)}>I don’t have strong political opinions </button>
                                    <button class="ui button" id="views" onClick={e => toggleWhy(e)}>I feel certain no one’s views would change</button>
                                </div>
                            </div>
                        </Fragment>);
                }
                function shareQuestion() {
                    return (
                        <Fragment>
                            <div id="question2" class="questions">
                                <div class="question">
                                    <p>Here are some of the reasons why others have said they would share their opinions with the group. Which best describes why you would share your views?</p>
                                </div>
                                <div class="options">
                                    <button class="ui button" id="compelled" onClick={e => toggleWhy(e)}>I would feel compelled to share my strong feelings about Trump</button>
                                    <button class="ui button" id="productive" onClick={e => toggleWhy(e)}>I think the conversation would be productive</button>
                                    <button class="ui button" id="inform" onClick={e => toggleWhy(e)}>I feel the people at the table need to learn the truth about Trump</button>
                                    <button class="ui button" id="important" onClick={e => toggleWhy(e)}>I think it would be important for them to know where I stand</button>
                                </div>
                            </div>
                        </Fragment>);
                }
                if (share === "Share") {
                    return shareQuestion();
                } else {
                    return avoidQuestion();
                }
            }}
        </Context.Consumer>
    )
}

export default Question2;